import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AlertasCardService } from '../alertas-card/alertas-card.service';
import { IAlertaPainelInterface } from '../shared/Util';
import { PopupConfigService } from '../popup-config/popup-config.service';
import { ObjectParam } from '../shared/interface/generic-interface';
import { NotificationService } from '../shared/notification.service';
import { NgIf, NgFor } from '@angular/common';
import { AlertaCardNotificacaoComponent } from '../alerta-card-notificacao/alerta-card-notificacao.component';

@Component({
    selector: 'app-alerta-notificacao',
    templateUrl: './alerta-notificacao.component.html',
    styleUrls: ['./alerta-notificacao.component.css'],
    standalone: true,
    imports: [NgIf, NgFor, AlertaCardNotificacaoComponent]
})
export class AlertaNotificacaoComponent implements OnChanges, OnInit {

  @Input() dashboardResult = []
  @Output() abrirModalMapa = new EventEmitter<any[]>(); 

  alertasNaoVisto: Array<IAlertaPainelInterface> = [];
  qtdAlertaAnterior = 0;
  audio: HTMLAudioElement; 
  mostraAlerta = true; 
  silenciado = true;  
  isUpdating = false;

  
  constructor(
    private alertasService: AlertasCardService,
    private popupConfigService: PopupConfigService,
    private notification: NotificationService
    ) {  
    }


  ngOnInit(): void {
    let algumAlertaAtivo = this.popupConfigService.alertas.some((alerta) => alerta.Ativo);
    if(algumAlertaAtivo){
      setInterval(() => {
        this.consultaAlertas();
      }, 60000 * 3)
    } 
  }

  ngOnChanges(): void {
   this.consultaAlertas()
  }


  async consultaAlertas(){
    let idsRoteiros = this.dashboardResult? this.dashboardResult.map((roteiro) => roteiro.IdRoteiro).join(',') : null
    if(idsRoteiros){
      let response = await this.alertasService.getAlertas(idsRoteiros);
      this.alertasNaoVisto = response.filter((alerta) => !alerta.Visualizado);
      if(this.alertasNaoVisto.length >  this.qtdAlertaAnterior){
        this.silenciado = false;       

        this.alteraMostraAlerta(false);      
        setTimeout(() => {
        this.alteraMostraAlerta(false);
        }, 100);       
        
      }
      this.qtdAlertaAnterior = this.alertasNaoVisto.length;
    }   
  }

  alteraMostraAlerta(clickUsuario: boolean =  false){
    if(clickUsuario){
      this.silenciado = true;
    }
    this.mostraAlerta = !this.mostraAlerta;
  }


  abrirMapa(alerta){
    this.abrirModalMapa.emit([alerta[0], 0, {latitude: alerta[2].Latitude, longitude: alerta[2].Longitude}]);
  }

  async marcaComoVisualizado() {   
    this.isUpdating = true; 
    
    try {
      if (this.alertasNaoVisto.length > 0) {
        let ids = this.alertasNaoVisto.map(alerta => alerta.RoteiroAlertaID);
        let objParam: ObjectParam = {
          roteiroAlerta: {
            RoteiroAlertaID: ids
          }
        };
        await this.alertasService.updateVisualizadoAlertaRoteiro(objParam);
        this.alertasNaoVisto.length = 0;
        //this.alteraMostraAlerta();    
      }  
    } catch (error) {
        console.error("Erro ao atualizar alertas:", error);
    } finally {
        this.isUpdating = false; 
    }
  }
}
